import {useEffect,useRef} from 'react';
import { useDispatch } from 'react-redux';
import BasePage from '../common/base';
import { AboutContainer } from './about.container';
import { BasePageStyles } from '../../hooks/styles';
import { Container } from '@mui/material';

const About = () => {
  const classes = BasePageStyles();
  const isFirstRender = useRef(true)
  const dispatch = useDispatch();
  
  useEffect(() => {
    isFirstRender.current = false
  }, [dispatch])

  return (
    <BasePage>
      <div className={classes.appBarSpacer}></div>
      <Container maxWidth={false} className={classes.container}>
        <AboutContainer />
      </Container>
    </BasePage>
  )
}

export default About;  